import styled from "styled-components";

export const SpanTextTitle = styled.span`
  color: #000;
  font-size: 14px;

  @media print {
    font-size: 9pt;
  }
`;

export const SpanTextTitleBold = styled.span`
  color: #000;
  font-weight: bold;
  font-size: 14px;

  @media print {
    font-size: 8pt;
  }
`;

export const SpanTextTitleDataBold = styled.span`
  color: #707070;
  font-weight: bold;
  font-size: 13px;
  margin-left: 1%;

  @media print {
    margin-left: 0;
    color: #000;
    font-size: 7pt;
  }
`;

export const TextParagraph = styled.div`
  text-align: center;
  font-size: 32px;
  font-weight: 500;
  margin-top: 10px;
  margin-bottom: 200px;

  @media print {
    font-size: 24pt;
  }
`;

export const SpanTextValueTitle = styled.span`
  color: #000;
  font-size: 12px;
  margin-left: 3%;
  width: 100%;

  @media print {
    font-size: 8pt;
    width: 200px;
    margin-left: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SpanTextValuePayment = styled.span`
  color: #1feb52;
  font-size: 12px;
  font-weight: 600;

  @media print {
    font-size: 7pt;
  }
`;
export const SpanTextValueTitlePayment = styled.span`
  color: #1FEB52;
  font-size: 12px;
  margin-left: 3%;
  width: 100%;

  @media print {
    font-size: 8pt;
    width: 200px;
    margin-left: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

export const SpanTextValue = styled.span`
  color: #000;
  font-size: 12px;
  font-weight: 600;

  @media print {
    font-size: 7pt;
  }
`;

export const TitleFaturaTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;

  @media print {
    font-size: 9pt;
  }
`;

export const DateFaturaTextValue = styled.span`
  color: #000;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
  width: 50%;
  display: flex;
  justify-content: flex-end;

  @media print {
    font-size: 8pt;
  }
`;

export const TitleH1 = styled.span`
  text-align: center;
  font-size: 54px;
  font-weight: 600;
  position: relative;
  margin-top: -65px;
`;

export const DescriptionH2 = styled.span`
  text-align: center;
  font-size: 30px;

  @media print {
    font-size: 9pt;
    color: #000;
  }
`;

export const Dividers = styled.hr`
  border-top: 3px dashed #7c7c7c;
  width: 100%;
  height: 1px;

  @media print {
    border-top: 1px solid #000;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 34%;
  height: 55%;
  /* max-width: 500px; */
  max-height: 400px;
  padding: 15px;
  margin: 0px;
  background-color: #f5f5f5;
  /* position: absolute; */

  @media print {
    background: transparent !important;
    color: #000 !important;
    text-shadow: none !important;
    filter: none !important;
    -ms-filter: none !important;
  }
`;